import { React } from 'react'
import { styled } from '@mui/material/styles'
import { Typography, Link, Box } from '@mui/material'

const sx = {
  cookie: (theme) => ({
    cursor: 'pointer',
    [theme.breakpoints.down(1024)]: {
      textDecoration: 'underline',
    },
  }),
  contact: (theme) => ({
    marginLeft: '4px',
    [theme.breakpoints.down(1024)]: {
      textDecoration: 'underline',
      textDecorationColor: "#0A78CD"
    },
  })
}

const Zendesk = styled(Typography)(() => ({
  whiteSpace: 'nowrap',
  textAlign: 'center',
  padding: '20px',
  Color: '#25245f',
}))

const Logos = styled(Typography)(() => ({
  fontSize: '14px',
  position: 'absolute',
  left: 0,
  marginLeft: '30px',
}))

function ZendeskLink(props) {
  const { page } = props
  return (
    <div>
      <Zendesk variant="caption">
        {page === 'LandingPage' && (
          <a href="https://clearbit.com/" rel="noreferrer" target="_blank">
            <Logos>Logos provided by Clearbit</Logos>
          </a>
        )}
        <Box color="#66668F">
          Need assistance?
          <Link
            href="https://share.hsforms.com/1n5-LEIiqTUyScicS-czMBAcdn4z"
            rel="noreferrer"
            target="_blank"
            underline="hover"
            sx={sx.contact}
          >
            <Typography component="span" variant="button3" color="color.blue20">
              Contact Us
            </Typography>
          </Link>
          <Box sx={{ marginTop: '10px' }}>
            <Link
              underline="hover"
              onClick={() => {
                var _hsp = (window._hsp = window._hsp || [])
                _hsp.push(['showBanner'])
              }}
            >
              {' '}
              <Typography
                sx={sx.cookie}
                component="span"
                variant="button3"
                color="color.blue20"
              >
                Cookie Settings
              </Typography>
            </Link>
          </Box>
        </Box>
      </Zendesk>
    </div>
  )
}

export default ZendeskLink
